import { FC } from 'react';
import { InterviewStatus } from '../../../common/Types';
import { SYM } from '../../Components/MaterialSymbol';
import styled from 'styled-components';

const InterviewStatusColorMap: Record<InterviewStatus, string> = {
  [InterviewStatus.INTERVIEW_NOT_STARTED]: 'gray',
  [InterviewStatus.INTERVIEW_STARTED]: 'yellow',
  [InterviewStatus.LAST_QUESTION_STARTED]: 'yellow-green',
  [InterviewStatus.INTERVIEW_COMPLETED]: 'green',
  [InterviewStatus.INTERVIEW_EXPIRED]: 'red',
};
const InterviewStatusIconMap: Record<InterviewStatus, string> = {
  [InterviewStatus.INTERVIEW_NOT_STARTED]: 'schedule',
  [InterviewStatus.INTERVIEW_STARTED]: 'play_circle',
  [InterviewStatus.LAST_QUESTION_STARTED]: 'question_answer',
  [InterviewStatus.INTERVIEW_COMPLETED]: 'check_circle',
  [InterviewStatus.INTERVIEW_EXPIRED]: 'timer_off',
};
const InterviewStatusLabelMap: Record<InterviewStatus, string> = {
  [InterviewStatus.INTERVIEW_NOT_STARTED]: 'Interview not started',
  [InterviewStatus.INTERVIEW_STARTED]: 'Interview in progress',
  [InterviewStatus.LAST_QUESTION_STARTED]: 'Last question started',
  [InterviewStatus.INTERVIEW_COMPLETED]: 'Interview completed',
  [InterviewStatus.INTERVIEW_EXPIRED]: 'Interview expired',
};

const StatusLabel = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5em;
`;

export type InterviewStatusLabelProps = {
  status: InterviewStatus | undefined;
};

export const InterviewStatusLabel: FC<InterviewStatusLabelProps> = ({ status }) => {
  return status ? (
    <StatusLabel
      style={{
        color: InterviewStatusColorMap[status],
      }}
    >
      <SYM>{InterviewStatusIconMap[status]}</SYM>
      {InterviewStatusLabelMap[status]}
    </StatusLabel>
  ) : undefined;
};
